import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import myImage from './Visual Planet.png';
import axios from 'axios';
import Swal from 'sweetalert2'; // Import SweetAlert
import './Admin.css';

function Choosecatpo() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const username = searchParams.get('loginlocation');
  const [file, setFile] = useState();
  const [sigfile, setSigFile] = useState();

  const handleUpload = () => {
    const formdata = new FormData();
    formdata.append('image', file);
    axios.post('https://appbackend.vpserver.online/upload', formdata)
      .then(res => {
        if (res.data.Status === "Success") {
          console.log("Succeeded");
          // Show sweet alert on success
          Swal.fire({
            icon: 'success',
            title: 'Seal Changed',
            text: 'Seal has been changed successfully!',
          });
        } else {
          console.log("Failed");
        }
      })
      .catch(err => console.log(err))
  };

  const handleSigUpload = () => {
    const sigformdata = new FormData();
    sigformdata.append('image', sigfile);
    axios.post('https://appbackend.vpserver.online/sigupload', sigformdata)
      .then(res => {
        if (res.data.Status === "Success") {
          console.log("Succeeded");
          // Show sweet alert on success
          Swal.fire({
            icon: 'success',
            title: 'Signature Changed',
            text: 'Signature has been changed successfully!',
          });
        } else {
          console.log("Failed");
        }
      })
      .catch(err => console.log(err))
  };

  const handlesigFile = (e) => {
    setSigFile(e.target.files[0])
  };
  const handleFile = (e) => {
    setFile(e.target.files[0])
  };

  return (
    <>

      <div className='admin-container2'>
        <div className='admin-panel'>
          <div className='admin-buttons'>
          <Link to={`/manageusers?loginlocation=${username}`} className='btn-default'>Users</Link>

            <Link to={`/managecatpo?loginlocation=${username}`} className='btn-default'>Category</Link>
            <Link to={`/manageproduct?loginlocation=${username}`} className='btn-default'> Product</Link>
            <Link to={`/managepositions?loginlocation=${username}`} className='btn-default'> Position</Link>

            <div className='file-input-container'>
              <input type="file" name="image" onChange={handleFile} />
              <button type="button" className="btn btn-primary" onClick={handleUpload}>
                Change Seal
              </button>
            </div>
            <div className='file-input-container'>
              <input type="file" name="image" onChange={handlesigFile} />
              <button type="button" className="btn btn-primary" onClick={handleSigUpload}>
                Change Signature
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Choosecatpo;
